module.exports = __webpack_public_path__ + "img/ic-blue-check.617a6127.svg";